import { render } from "./DesignersChoicePage.vue?vue&type=template&id=dea18ee8&lang=pug"
import script from "./DesignersChoicePage.vue?vue&type=script&lang=js"
export * from "./DesignersChoicePage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/chiedocover/chiedohome.com/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__